import { Archive, Bell, BookOpen, Database, Image, LogOut, Menu, Network, Plus, Search, Settings, User, Users } from 'lucide-react';
import type { AuthSession } from '../types';
import { cx } from './ui';

export type WorkspaceAction = 'tree' | 'members' | 'media' | 'data' | 'settings';

const actions: Array<{ id: WorkspaceAction; label: string; icon: typeof Network }> = [
  { id: 'tree', label: '族谱', icon: Network },
  { id: 'members', label: '族人', icon: Users },
  { id: 'media', label: '影像', icon: Image },
  { id: 'data', label: '数据', icon: BookOpen },
  { id: 'settings', label: '设置', icon: Settings }
];

export function DesktopSidebar({ active, onAction }: { active: WorkspaceAction; onAction: (action: WorkspaceAction) => void }) {
  return (
    <aside className="desktop-sidebar">
      <div className="brand-mark"><Archive /><span>云谱</span></div>
      <nav>{actions.map(({ id, label, icon: Icon }) => <button key={id} type="button" className={cx(active === id && 'active')} onClick={() => onAction(id)}><Icon /><span>{label}</span></button>)}</nav>
      <div className="cultural-mark"><span>桂水</span><i /><span>湘流</span></div>
    </aside>
  );
}

export function AppTopbar({ query, onQuery, online, session, pendingCount, onAdd, onReview, onLogin, onLogout, onOpenMenu }: { query: string; onQuery: (value: string) => void; online: boolean; session: AuthSession; pendingCount: number; onAdd: () => void; onReview: () => void; onLogin: () => void; onLogout: () => void; onOpenMenu: () => void }) {
  return (
    <header className="app-topbar">
      <button type="button" className="topbar-menu" onClick={onOpenMenu} aria-label="打开导航"><Menu /></button>
      <div className="mobile-brand"><Archive /><strong>云谱</strong></div>
      <label className="global-search"><Search /><input value={query} onChange={(event) => onQuery(event.target.value)} placeholder="搜索姓名、分支、地区" /></label>
      <span className={cx('connection-state', online ? 'online' : 'offline')}><i />{online ? '已连接' : '离线'}</span>
      <div className="topbar-actions">
        {session.role !== 'guest' && <button type="button" className="button compact" onClick={onAdd}><Plus />新增族人</button>}
        {session.role === 'admin' && <button type="button" className="icon-button notification" onClick={onReview} title="审核队列"><Bell />{pendingCount > 0 && <span>{pendingCount}</span>}</button>}
        {session.role === 'guest' ? <button type="button" className="button primary compact" onClick={onLogin}><User />登录</button> : <button type="button" className="profile-button" onClick={onLogout}><span><strong>{session.name}</strong><small>{session.role === 'admin' ? '管理员' : '家族成员'}</small></span><LogOut /></button>}
      </div>
    </header>
  );
}

export function MobileNavigation({ active, session, onAction, onLogin }: { active: WorkspaceAction; session: AuthSession; onAction: (action: WorkspaceAction) => void; onLogin: () => void }) {
  return (
    <nav className="mobile-navigation">
      {actions.slice(0, 4).map(({ id, label, icon: Icon }) => <button key={id} type="button" className={cx(active === id && 'active')} onClick={() => onAction(id)}><Icon /><span>{label}</span></button>)}
      <button type="button" onClick={session.role === 'guest' ? onLogin : () => onAction('settings')}><User /><span>{session.role === 'guest' ? '登录' : '我的'}</span></button>
    </nav>
  );
}

export function SearchPopover({ query, people, onSelect }: { query: string; people: Array<{ id: string; name: string; generation: number; branch: string; origin: string }>; onSelect: (id: string) => void }) {
  if (!query.trim()) return null;
  const results = people.filter((person) => [person.name, person.branch, person.origin, String(person.generation)].some((value) => value.includes(query.trim()))).slice(0, 8);
  return (
    <div className="search-popover">
      {results.map((person) => <button key={person.id} type="button" onClick={() => onSelect(person.id)}><span><strong>{person.name}</strong><small>{person.generation}世 · {person.branch}</small></span><em>{person.origin}</em></button>)}
      {results.length === 0 && <p>没有匹配族人</p>}
    </div>
  );
}
